export default __webpack_public_path__ + "static/media/elevator-call-category-icon.dbd7f7df.svg";